
import axios from 'axios'

export const getEmailTemplate = async(organizationId, programId, eventTypeId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/eventType/${eventTypeId}/emailtemplatepreview`)
    return response.data
}


export const getEventEmailTemplate = async(organizationId, programId, eventId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/event/${eventId}/emailtemplatepreview`)
    return response.data
}

export const sendEventPreviewEmail = async(organizationId, programId, eventId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/event/${eventId}/sendpreviewemail`)
    return response.data
}

export const sendEventTypePreviewEmail = async(organizationId, programId, eventTypeId) => {
    const response = await axios.get(`/organization/${organizationId}/program/${programId}/eventType/${eventTypeId}/sendpreviewemail`)
    return response.data
}